import type { AppRouteRecordRaw } from '@/router/types'
import WorkerManage from '@/views/zzy/workerManage.vue'

// 指掌易
export const zzyRoutes: AppRouteRecordRaw[] = [
  {
    path: 'workerManage',
    name: 'WorkerManage',
    iframeComponent: WorkerManage,
    meta: { title: '工作机后台管理', keepAlive: true, isIFrame: true }
  }
]
